// Only an explicit appearance deep link changes the builder's opening panel.
function openAppearance(){
 if(location.hash!=='#appearance')return;
 const root=document.querySelector('[data-assembly-app]');if(!root)return;
 const open=()=>{if(!root.dataset.configuration)return false;root.querySelector('[data-hud-tab="webbing"]').click();root.querySelector('.sa-visual').scrollIntoView({block:'start'});return true;};
 if(open())return;
 const watch=new MutationObserver(()=>{if(open())watch.disconnect();});watch.observe(root,{attributes:true,attributeFilter:['data-configuration']});setTimeout(()=>watch.disconnect(),15000);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',openAppearance,{once:true});else openAppearance();
window.addEventListener('hashchange',openAppearance);
